import { defineMessages } from 'react-intl';

export const i18n: {
	backgroundColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	colorValidationFailMessage: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	colorValidationSuccessMessage: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cornerRadius: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	textColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	backgroundColor: {
		id: 'company-hub.spotlight-extension.spotlight.background.color',
		defaultMessage: 'Background color',
		description: 'Text labeling a customization option for background color',
	},
	textColor: {
		id: 'company-hub.spotlight-extension.spotlight.text.color',
		defaultMessage: 'Text color',
		description: 'Text labeling a customization option for text color',
	},
	colorValidationSuccessMessage: {
		id: 'company-hub.spotlight-extension.spotlight.color-contrast.success',
		defaultMessage: 'Your text and background colors work well for readability.',
		description:
			'Message that informs user that their color selections meets contrast ratio accessibility standards',
	},
	colorValidationFailMessage: {
		id: 'company-hub.spotlight-extension.spotlight.color-contrast.fail',
		defaultMessage: "Your text and background colors don't work well for readability.",
		description:
			'Message that informs user that their color selections does not meet contrast ratio accessibility standards',
	},
	cornerRadius: {
		id: 'company-hub.spotlight-extension.spotlight.corner.radius.non-final',
		defaultMessage: 'Corners',
		description: 'Text labeling a customization option for corner radius',
	},
});
